export enum VendorSettingsPage {
  LEGAL = 'LEGAL',
  PUBLIC = 'PUBLIC',
  BOOKING = 'BOOKING',
  FIDELITY = 'FIDELITY',
}
